import CommandButton from './CommandButton';
import FormDropdown from './FormDropdown';
import InsertImageDropdown from './InsertImageDropdown';
import InsertLinkDropdown from './InsertLinkDropdown';
import ListButton from './ListButton';
import MarkButton from './MarkButton';
import NodeTypeDropdown from './NodeTypeDropdown';
import ProseMirrorMenu from './ProseMirrorMenu';
export const components = {
  CommandButton: CommandButton,
  FormDropdown: FormDropdown,
  InsertImageDropdown: InsertImageDropdown,
  InsertLinkDropdown: InsertLinkDropdown,
  ListButton: ListButton,
  MarkButton: MarkButton,
  NodeTypeDropdown: NodeTypeDropdown,
  ProseMirrorMenu: ProseMirrorMenu
};
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/components', null);